/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import {
  RemarkType,
  remarkTypeToNumber,
  remarkTypeFromJSON,
  remarkTypeToJSON,
} from "./RemarkType";

export enum TourOperatorCategory {
  Classic = "Classic",
  Dynamic = "Dynamic",
}

export function tourOperatorCategoryFromJSON(
  object: any
): TourOperatorCategory {
  switch (object) {
    case 0:
    case "Classic":
      return TourOperatorCategory.Classic;
    case 1:
    case "Dynamic":
      return TourOperatorCategory.Dynamic;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum TourOperatorCategory"
      );
  }
}

export function tourOperatorCategoryToJSON(
  object: TourOperatorCategory
): string {
  switch (object) {
    case TourOperatorCategory.Classic:
      return "Classic";
    case TourOperatorCategory.Dynamic:
      return "Dynamic";
    default:
      return "UNKNOWN";
  }
}

export function tourOperatorCategoryToNumber(
  object: TourOperatorCategory
): number {
  switch (object) {
    case TourOperatorCategory.Classic:
      return 0;
    case TourOperatorCategory.Dynamic:
      return 1;
    default:
      return 0;
  }
}

export interface TourOperatorRating {
  type: string;
  countsByRating: number[];
  averagesByRating: RatingComponent[];
  averages?: RatingComponent;
}

export interface RatingComponent {
  costBenefitRatio: number;
  travelGuidance: number;
  organizerHandling: number;
  transfer: number;
  asInCatalogue: number;
}

export interface TourOperatorRemark {
  isCancellation: boolean;
  isVoucherTitleDescription: boolean;
  id: number;
  title: string;
  titleShort: string;
  description: string;
  links: TourOperatorRemark_Link[];
  type: RemarkType;
  flag: TourOperatorRemark_Flag;
}

export enum TourOperatorRemark_Flag {
  Standard = "Standard",
  Negative = "Negative",
  Info = "Info",
}

export function tourOperatorRemark_FlagFromJSON(
  object: any
): TourOperatorRemark_Flag {
  switch (object) {
    case 0:
    case "Standard":
      return TourOperatorRemark_Flag.Standard;
    case 1:
    case "Negative":
      return TourOperatorRemark_Flag.Negative;
    case 2:
    case "Info":
      return TourOperatorRemark_Flag.Info;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " +
          object +
          " for enum TourOperatorRemark_Flag"
      );
  }
}

export function tourOperatorRemark_FlagToJSON(
  object: TourOperatorRemark_Flag
): string {
  switch (object) {
    case TourOperatorRemark_Flag.Standard:
      return "Standard";
    case TourOperatorRemark_Flag.Negative:
      return "Negative";
    case TourOperatorRemark_Flag.Info:
      return "Info";
    default:
      return "UNKNOWN";
  }
}

export function tourOperatorRemark_FlagToNumber(
  object: TourOperatorRemark_Flag
): number {
  switch (object) {
    case TourOperatorRemark_Flag.Standard:
      return 0;
    case TourOperatorRemark_Flag.Negative:
      return 1;
    case TourOperatorRemark_Flag.Info:
      return 2;
    default:
      return 0;
  }
}

export interface TourOperatorRemark_Link {
  text: string;
  url: string;
}

export interface TourOperatorWarning {
  isSoft: boolean;
  id: number;
  title: string;
  description: string;
}

/**
 * TourOperatorVoucher is defined in RemarkType-Enum and cannot
 * be declared as message then
 */
export interface TourOperatorVoucherItem {
  isCoupon: boolean;
  title: string;
  description: string;
}

export interface TourOperator {
  isAvailable: boolean;
  code: string;
  name: string;
  image: string;
  description: string;
  warnings: TourOperatorWarning[];
  discounts: { [key: number]: TourOperatorVoucherItem };
  refunds: { [key: number]: TourOperatorVoucherItem };
  rating?: TourOperator_Rating;
  address?: TourOperator_Address;
}

export interface TourOperator_Rating {
  count: number;
  average: number;
  detail?: TourOperatorRating;
}

export interface TourOperator_Address {
  companyName: string;
  street: string;
  zipCode: string;
  city: string;
  phone: string;
}

export interface TourOperator_DiscountsEntry {
  key: number;
  value?: TourOperatorVoucherItem;
}

export interface TourOperator_RefundsEntry {
  key: number;
  value?: TourOperatorVoucherItem;
}

export interface TourOperatorList {
  items: { [key: string]: TourOperator };
}

export interface TourOperatorList_ItemsEntry {
  key: string;
  value?: TourOperator;
}

function createBaseTourOperatorRating(): TourOperatorRating {
  return {
    type: "",
    countsByRating: [],
    averagesByRating: [],
    averages: undefined,
  };
}

export const TourOperatorRating = {
  encode(
    message: TourOperatorRating,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    writer.uint32(18).fork();
    for (const v of message.countsByRating) {
      writer.uint32(v);
    }
    writer.ldelim();
    for (const v of message.averagesByRating) {
      RatingComponent.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.averages !== undefined) {
      RatingComponent.encode(
        message.averages,
        writer.uint32(34).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TourOperatorRating {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorRating();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.type = reader.string();
          break;
        case 2:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.countsByRating.push(reader.uint32());
            }
          } else {
            message.countsByRating.push(reader.uint32());
          }
          break;
        case 3:
          message.averagesByRating.push(
            RatingComponent.decode(reader, reader.uint32())
          );
          break;
        case 4:
          message.averages = RatingComponent.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorRating {
    return {
      type: isSet(object.type) ? String(object.type) : "",
      countsByRating: Array.isArray(object?.countsByRating)
        ? object.countsByRating.map((e: any) => Number(e))
        : [],
      averagesByRating: Array.isArray(object?.averagesByRating)
        ? object.averagesByRating.map((e: any) => RatingComponent.fromJSON(e))
        : [],
      averages: isSet(object.averages)
        ? RatingComponent.fromJSON(object.averages)
        : undefined,
    };
  },

  toJSON(message: TourOperatorRating): unknown {
    const obj: any = {};
    message.type !== undefined && (obj.type = message.type);
    if (message.countsByRating) {
      obj.countsByRating = message.countsByRating.map((e) => Math.round(e));
    } else {
      obj.countsByRating = [];
    }
    if (message.averagesByRating) {
      obj.averagesByRating = message.averagesByRating.map((e) =>
        e ? RatingComponent.toJSON(e) : undefined
      );
    } else {
      obj.averagesByRating = [];
    }
    message.averages !== undefined &&
      (obj.averages = message.averages
        ? RatingComponent.toJSON(message.averages)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<TourOperatorRating>): TourOperatorRating {
    const message = createBaseTourOperatorRating();
    message.type = object.type ?? "";
    message.countsByRating = object.countsByRating?.map((e) => e) || [];
    message.averagesByRating =
      object.averagesByRating?.map((e) => RatingComponent.fromPartial(e)) || [];
    message.averages =
      object.averages !== undefined && object.averages !== null
        ? RatingComponent.fromPartial(object.averages)
        : undefined;
    return message;
  },
};

function createBaseRatingComponent(): RatingComponent {
  return {
    costBenefitRatio: 0,
    travelGuidance: 0,
    organizerHandling: 0,
    transfer: 0,
    asInCatalogue: 0,
  };
}

export const RatingComponent = {
  encode(
    message: RatingComponent,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.costBenefitRatio !== 0) {
      writer.uint32(13).float(message.costBenefitRatio);
    }
    if (message.travelGuidance !== 0) {
      writer.uint32(21).float(message.travelGuidance);
    }
    if (message.organizerHandling !== 0) {
      writer.uint32(29).float(message.organizerHandling);
    }
    if (message.transfer !== 0) {
      writer.uint32(37).float(message.transfer);
    }
    if (message.asInCatalogue !== 0) {
      writer.uint32(45).float(message.asInCatalogue);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RatingComponent {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRatingComponent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.costBenefitRatio = reader.float();
          break;
        case 2:
          message.travelGuidance = reader.float();
          break;
        case 3:
          message.organizerHandling = reader.float();
          break;
        case 4:
          message.transfer = reader.float();
          break;
        case 5:
          message.asInCatalogue = reader.float();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RatingComponent {
    return {
      costBenefitRatio: isSet(object.costBenefitRatio)
        ? Number(object.costBenefitRatio)
        : 0,
      travelGuidance: isSet(object.travelGuidance)
        ? Number(object.travelGuidance)
        : 0,
      organizerHandling: isSet(object.organizerHandling)
        ? Number(object.organizerHandling)
        : 0,
      transfer: isSet(object.transfer) ? Number(object.transfer) : 0,
      asInCatalogue: isSet(object.asInCatalogue)
        ? Number(object.asInCatalogue)
        : 0,
    };
  },

  toJSON(message: RatingComponent): unknown {
    const obj: any = {};
    message.costBenefitRatio !== undefined &&
      (obj.costBenefitRatio = message.costBenefitRatio);
    message.travelGuidance !== undefined &&
      (obj.travelGuidance = message.travelGuidance);
    message.organizerHandling !== undefined &&
      (obj.organizerHandling = message.organizerHandling);
    message.transfer !== undefined && (obj.transfer = message.transfer);
    message.asInCatalogue !== undefined &&
      (obj.asInCatalogue = message.asInCatalogue);
    return obj;
  },

  fromPartial(object: DeepPartial<RatingComponent>): RatingComponent {
    const message = createBaseRatingComponent();
    message.costBenefitRatio = object.costBenefitRatio ?? 0;
    message.travelGuidance = object.travelGuidance ?? 0;
    message.organizerHandling = object.organizerHandling ?? 0;
    message.transfer = object.transfer ?? 0;
    message.asInCatalogue = object.asInCatalogue ?? 0;
    return message;
  },
};

function createBaseTourOperatorRemark(): TourOperatorRemark {
  return {
    isCancellation: false,
    isVoucherTitleDescription: false,
    id: 0,
    title: "",
    titleShort: "",
    description: "",
    links: [],
    type: RemarkType.TypeUnknown,
    flag: TourOperatorRemark_Flag.Standard,
  };
}

export const TourOperatorRemark = {
  encode(
    message: TourOperatorRemark,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isCancellation === true) {
      writer.uint32(56).bool(message.isCancellation);
    }
    if (message.isVoucherTitleDescription === true) {
      writer.uint32(64).bool(message.isVoucherTitleDescription);
    }
    if (message.id !== 0) {
      writer.uint32(8).int32(message.id);
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    if (message.titleShort !== "") {
      writer.uint32(74).string(message.titleShort);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    for (const v of message.links) {
      TourOperatorRemark_Link.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    if (message.type !== RemarkType.TypeUnknown) {
      writer.uint32(16).int32(remarkTypeToNumber(message.type));
    }
    if (message.flag !== TourOperatorRemark_Flag.Standard) {
      writer.uint32(48).int32(tourOperatorRemark_FlagToNumber(message.flag));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TourOperatorRemark {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorRemark();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 7:
          message.isCancellation = reader.bool();
          break;
        case 8:
          message.isVoucherTitleDescription = reader.bool();
          break;
        case 1:
          message.id = reader.int32();
          break;
        case 3:
          message.title = reader.string();
          break;
        case 9:
          message.titleShort = reader.string();
          break;
        case 4:
          message.description = reader.string();
          break;
        case 5:
          message.links.push(
            TourOperatorRemark_Link.decode(reader, reader.uint32())
          );
          break;
        case 2:
          message.type = remarkTypeFromJSON(reader.int32());
          break;
        case 6:
          message.flag = tourOperatorRemark_FlagFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorRemark {
    return {
      isCancellation: isSet(object.isCancellation)
        ? Boolean(object.isCancellation)
        : false,
      isVoucherTitleDescription: isSet(object.isVoucherTitleDescription)
        ? Boolean(object.isVoucherTitleDescription)
        : false,
      id: isSet(object.id) ? Number(object.id) : 0,
      title: isSet(object.title) ? String(object.title) : "",
      titleShort: isSet(object.titleShort) ? String(object.titleShort) : "",
      description: isSet(object.description) ? String(object.description) : "",
      links: Array.isArray(object?.links)
        ? object.links.map((e: any) => TourOperatorRemark_Link.fromJSON(e))
        : [],
      type: isSet(object.type)
        ? remarkTypeFromJSON(object.type)
        : RemarkType.TypeUnknown,
      flag: isSet(object.flag)
        ? tourOperatorRemark_FlagFromJSON(object.flag)
        : TourOperatorRemark_Flag.Standard,
    };
  },

  toJSON(message: TourOperatorRemark): unknown {
    const obj: any = {};
    message.isCancellation !== undefined &&
      (obj.isCancellation = message.isCancellation);
    message.isVoucherTitleDescription !== undefined &&
      (obj.isVoucherTitleDescription = message.isVoucherTitleDescription);
    message.id !== undefined && (obj.id = Math.round(message.id));
    message.title !== undefined && (obj.title = message.title);
    message.titleShort !== undefined && (obj.titleShort = message.titleShort);
    message.description !== undefined &&
      (obj.description = message.description);
    if (message.links) {
      obj.links = message.links.map((e) =>
        e ? TourOperatorRemark_Link.toJSON(e) : undefined
      );
    } else {
      obj.links = [];
    }
    message.type !== undefined && (obj.type = remarkTypeToJSON(message.type));
    message.flag !== undefined &&
      (obj.flag = tourOperatorRemark_FlagToJSON(message.flag));
    return obj;
  },

  fromPartial(object: DeepPartial<TourOperatorRemark>): TourOperatorRemark {
    const message = createBaseTourOperatorRemark();
    message.isCancellation = object.isCancellation ?? false;
    message.isVoucherTitleDescription =
      object.isVoucherTitleDescription ?? false;
    message.id = object.id ?? 0;
    message.title = object.title ?? "";
    message.titleShort = object.titleShort ?? "";
    message.description = object.description ?? "";
    message.links =
      object.links?.map((e) => TourOperatorRemark_Link.fromPartial(e)) || [];
    message.type = object.type ?? RemarkType.TypeUnknown;
    message.flag = object.flag ?? TourOperatorRemark_Flag.Standard;
    return message;
  },
};

function createBaseTourOperatorRemark_Link(): TourOperatorRemark_Link {
  return { text: "", url: "" };
}

export const TourOperatorRemark_Link = {
  encode(
    message: TourOperatorRemark_Link,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TourOperatorRemark_Link {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorRemark_Link();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.text = reader.string();
          break;
        case 2:
          message.url = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorRemark_Link {
    return {
      text: isSet(object.text) ? String(object.text) : "",
      url: isSet(object.url) ? String(object.url) : "",
    };
  },

  toJSON(message: TourOperatorRemark_Link): unknown {
    const obj: any = {};
    message.text !== undefined && (obj.text = message.text);
    message.url !== undefined && (obj.url = message.url);
    return obj;
  },

  fromPartial(
    object: DeepPartial<TourOperatorRemark_Link>
  ): TourOperatorRemark_Link {
    const message = createBaseTourOperatorRemark_Link();
    message.text = object.text ?? "";
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseTourOperatorWarning(): TourOperatorWarning {
  return { isSoft: false, id: 0, title: "", description: "" };
}

export const TourOperatorWarning = {
  encode(
    message: TourOperatorWarning,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isSoft === true) {
      writer.uint32(8).bool(message.isSoft);
    }
    if (message.id !== 0) {
      writer.uint32(32).uint32(message.id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TourOperatorWarning {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorWarning();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.isSoft = reader.bool();
          break;
        case 4:
          message.id = reader.uint32();
          break;
        case 2:
          message.title = reader.string();
          break;
        case 3:
          message.description = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorWarning {
    return {
      isSoft: isSet(object.isSoft) ? Boolean(object.isSoft) : false,
      id: isSet(object.id) ? Number(object.id) : 0,
      title: isSet(object.title) ? String(object.title) : "",
      description: isSet(object.description) ? String(object.description) : "",
    };
  },

  toJSON(message: TourOperatorWarning): unknown {
    const obj: any = {};
    message.isSoft !== undefined && (obj.isSoft = message.isSoft);
    message.id !== undefined && (obj.id = Math.round(message.id));
    message.title !== undefined && (obj.title = message.title);
    message.description !== undefined &&
      (obj.description = message.description);
    return obj;
  },

  fromPartial(object: DeepPartial<TourOperatorWarning>): TourOperatorWarning {
    const message = createBaseTourOperatorWarning();
    message.isSoft = object.isSoft ?? false;
    message.id = object.id ?? 0;
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseTourOperatorVoucherItem(): TourOperatorVoucherItem {
  return { isCoupon: false, title: "", description: "" };
}

export const TourOperatorVoucherItem = {
  encode(
    message: TourOperatorVoucherItem,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isCoupon === true) {
      writer.uint32(24).bool(message.isCoupon);
    }
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TourOperatorVoucherItem {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorVoucherItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          message.isCoupon = reader.bool();
          break;
        case 1:
          message.title = reader.string();
          break;
        case 2:
          message.description = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorVoucherItem {
    return {
      isCoupon: isSet(object.isCoupon) ? Boolean(object.isCoupon) : false,
      title: isSet(object.title) ? String(object.title) : "",
      description: isSet(object.description) ? String(object.description) : "",
    };
  },

  toJSON(message: TourOperatorVoucherItem): unknown {
    const obj: any = {};
    message.isCoupon !== undefined && (obj.isCoupon = message.isCoupon);
    message.title !== undefined && (obj.title = message.title);
    message.description !== undefined &&
      (obj.description = message.description);
    return obj;
  },

  fromPartial(
    object: DeepPartial<TourOperatorVoucherItem>
  ): TourOperatorVoucherItem {
    const message = createBaseTourOperatorVoucherItem();
    message.isCoupon = object.isCoupon ?? false;
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseTourOperator(): TourOperator {
  return {
    isAvailable: false,
    code: "",
    name: "",
    image: "",
    description: "",
    warnings: [],
    discounts: {},
    refunds: {},
    rating: undefined,
    address: undefined,
  };
}

export const TourOperator = {
  encode(
    message: TourOperator,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isAvailable === true) {
      writer.uint32(8).bool(message.isAvailable);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.image !== "") {
      writer.uint32(34).string(message.image);
    }
    if (message.description !== "") {
      writer.uint32(42).string(message.description);
    }
    for (const v of message.warnings) {
      TourOperatorWarning.encode(v!, writer.uint32(58).fork()).ldelim();
    }
    Object.entries(message.discounts).forEach(([key, value]) => {
      TourOperator_DiscountsEntry.encode(
        { key: key as any, value },
        writer.uint32(66).fork()
      ).ldelim();
    });
    Object.entries(message.refunds).forEach(([key, value]) => {
      TourOperator_RefundsEntry.encode(
        { key: key as any, value },
        writer.uint32(82).fork()
      ).ldelim();
    });
    if (message.rating !== undefined) {
      TourOperator_Rating.encode(
        message.rating,
        writer.uint32(50).fork()
      ).ldelim();
    }
    if (message.address !== undefined) {
      TourOperator_Address.encode(
        message.address,
        writer.uint32(74).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TourOperator {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperator();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.isAvailable = reader.bool();
          break;
        case 2:
          message.code = reader.string();
          break;
        case 3:
          message.name = reader.string();
          break;
        case 4:
          message.image = reader.string();
          break;
        case 5:
          message.description = reader.string();
          break;
        case 7:
          message.warnings.push(
            TourOperatorWarning.decode(reader, reader.uint32())
          );
          break;
        case 8:
          const entry8 = TourOperator_DiscountsEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry8.value !== undefined) {
            message.discounts[entry8.key] = entry8.value;
          }
          break;
        case 10:
          const entry10 = TourOperator_RefundsEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry10.value !== undefined) {
            message.refunds[entry10.key] = entry10.value;
          }
          break;
        case 6:
          message.rating = TourOperator_Rating.decode(reader, reader.uint32());
          break;
        case 9:
          message.address = TourOperator_Address.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperator {
    return {
      isAvailable: isSet(object.isAvailable)
        ? Boolean(object.isAvailable)
        : false,
      code: isSet(object.code) ? String(object.code) : "",
      name: isSet(object.name) ? String(object.name) : "",
      image: isSet(object.image) ? String(object.image) : "",
      description: isSet(object.description) ? String(object.description) : "",
      warnings: Array.isArray(object?.warnings)
        ? object.warnings.map((e: any) => TourOperatorWarning.fromJSON(e))
        : [],
      discounts: isObject(object.discounts)
        ? Object.entries(object.discounts).reduce<{
            [key: number]: TourOperatorVoucherItem;
          }>((acc, [key, value]) => {
            acc[Number(key)] = TourOperatorVoucherItem.fromJSON(value);
            return acc;
          }, {})
        : {},
      refunds: isObject(object.refunds)
        ? Object.entries(object.refunds).reduce<{
            [key: number]: TourOperatorVoucherItem;
          }>((acc, [key, value]) => {
            acc[Number(key)] = TourOperatorVoucherItem.fromJSON(value);
            return acc;
          }, {})
        : {},
      rating: isSet(object.rating)
        ? TourOperator_Rating.fromJSON(object.rating)
        : undefined,
      address: isSet(object.address)
        ? TourOperator_Address.fromJSON(object.address)
        : undefined,
    };
  },

  toJSON(message: TourOperator): unknown {
    const obj: any = {};
    message.isAvailable !== undefined &&
      (obj.isAvailable = message.isAvailable);
    message.code !== undefined && (obj.code = message.code);
    message.name !== undefined && (obj.name = message.name);
    message.image !== undefined && (obj.image = message.image);
    message.description !== undefined &&
      (obj.description = message.description);
    if (message.warnings) {
      obj.warnings = message.warnings.map((e) =>
        e ? TourOperatorWarning.toJSON(e) : undefined
      );
    } else {
      obj.warnings = [];
    }
    obj.discounts = {};
    if (message.discounts) {
      Object.entries(message.discounts).forEach(([k, v]) => {
        obj.discounts[k] = TourOperatorVoucherItem.toJSON(v);
      });
    }
    obj.refunds = {};
    if (message.refunds) {
      Object.entries(message.refunds).forEach(([k, v]) => {
        obj.refunds[k] = TourOperatorVoucherItem.toJSON(v);
      });
    }
    message.rating !== undefined &&
      (obj.rating = message.rating
        ? TourOperator_Rating.toJSON(message.rating)
        : undefined);
    message.address !== undefined &&
      (obj.address = message.address
        ? TourOperator_Address.toJSON(message.address)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<TourOperator>): TourOperator {
    const message = createBaseTourOperator();
    message.isAvailable = object.isAvailable ?? false;
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    message.image = object.image ?? "";
    message.description = object.description ?? "";
    message.warnings =
      object.warnings?.map((e) => TourOperatorWarning.fromPartial(e)) || [];
    message.discounts = Object.entries(object.discounts ?? {}).reduce<{
      [key: number]: TourOperatorVoucherItem;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[Number(key)] = TourOperatorVoucherItem.fromPartial(value);
      }
      return acc;
    }, {});
    message.refunds = Object.entries(object.refunds ?? {}).reduce<{
      [key: number]: TourOperatorVoucherItem;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[Number(key)] = TourOperatorVoucherItem.fromPartial(value);
      }
      return acc;
    }, {});
    message.rating =
      object.rating !== undefined && object.rating !== null
        ? TourOperator_Rating.fromPartial(object.rating)
        : undefined;
    message.address =
      object.address !== undefined && object.address !== null
        ? TourOperator_Address.fromPartial(object.address)
        : undefined;
    return message;
  },
};

function createBaseTourOperator_Rating(): TourOperator_Rating {
  return { count: 0, average: 0, detail: undefined };
}

export const TourOperator_Rating = {
  encode(
    message: TourOperator_Rating,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.count !== 0) {
      writer.uint32(8).uint32(message.count);
    }
    if (message.average !== 0) {
      writer.uint32(21).float(message.average);
    }
    if (message.detail !== undefined) {
      TourOperatorRating.encode(
        message.detail,
        writer.uint32(26).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TourOperator_Rating {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperator_Rating();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.count = reader.uint32();
          break;
        case 2:
          message.average = reader.float();
          break;
        case 3:
          message.detail = TourOperatorRating.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperator_Rating {
    return {
      count: isSet(object.count) ? Number(object.count) : 0,
      average: isSet(object.average) ? Number(object.average) : 0,
      detail: isSet(object.detail)
        ? TourOperatorRating.fromJSON(object.detail)
        : undefined,
    };
  },

  toJSON(message: TourOperator_Rating): unknown {
    const obj: any = {};
    message.count !== undefined && (obj.count = Math.round(message.count));
    message.average !== undefined && (obj.average = message.average);
    message.detail !== undefined &&
      (obj.detail = message.detail
        ? TourOperatorRating.toJSON(message.detail)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<TourOperator_Rating>): TourOperator_Rating {
    const message = createBaseTourOperator_Rating();
    message.count = object.count ?? 0;
    message.average = object.average ?? 0;
    message.detail =
      object.detail !== undefined && object.detail !== null
        ? TourOperatorRating.fromPartial(object.detail)
        : undefined;
    return message;
  },
};

function createBaseTourOperator_Address(): TourOperator_Address {
  return { companyName: "", street: "", zipCode: "", city: "", phone: "" };
}

export const TourOperator_Address = {
  encode(
    message: TourOperator_Address,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.companyName !== "") {
      writer.uint32(10).string(message.companyName);
    }
    if (message.street !== "") {
      writer.uint32(18).string(message.street);
    }
    if (message.zipCode !== "") {
      writer.uint32(26).string(message.zipCode);
    }
    if (message.city !== "") {
      writer.uint32(34).string(message.city);
    }
    if (message.phone !== "") {
      writer.uint32(42).string(message.phone);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TourOperator_Address {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperator_Address();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.companyName = reader.string();
          break;
        case 2:
          message.street = reader.string();
          break;
        case 3:
          message.zipCode = reader.string();
          break;
        case 4:
          message.city = reader.string();
          break;
        case 5:
          message.phone = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperator_Address {
    return {
      companyName: isSet(object.companyName) ? String(object.companyName) : "",
      street: isSet(object.street) ? String(object.street) : "",
      zipCode: isSet(object.zipCode) ? String(object.zipCode) : "",
      city: isSet(object.city) ? String(object.city) : "",
      phone: isSet(object.phone) ? String(object.phone) : "",
    };
  },

  toJSON(message: TourOperator_Address): unknown {
    const obj: any = {};
    message.companyName !== undefined &&
      (obj.companyName = message.companyName);
    message.street !== undefined && (obj.street = message.street);
    message.zipCode !== undefined && (obj.zipCode = message.zipCode);
    message.city !== undefined && (obj.city = message.city);
    message.phone !== undefined && (obj.phone = message.phone);
    return obj;
  },

  fromPartial(object: DeepPartial<TourOperator_Address>): TourOperator_Address {
    const message = createBaseTourOperator_Address();
    message.companyName = object.companyName ?? "";
    message.street = object.street ?? "";
    message.zipCode = object.zipCode ?? "";
    message.city = object.city ?? "";
    message.phone = object.phone ?? "";
    return message;
  },
};

function createBaseTourOperator_DiscountsEntry(): TourOperator_DiscountsEntry {
  return { key: 0, value: undefined };
}

export const TourOperator_DiscountsEntry = {
  encode(
    message: TourOperator_DiscountsEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== 0) {
      writer.uint32(8).uint32(message.key);
    }
    if (message.value !== undefined) {
      TourOperatorVoucherItem.encode(
        message.value,
        writer.uint32(18).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TourOperator_DiscountsEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperator_DiscountsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.uint32();
          break;
        case 2:
          message.value = TourOperatorVoucherItem.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperator_DiscountsEntry {
    return {
      key: isSet(object.key) ? Number(object.key) : 0,
      value: isSet(object.value)
        ? TourOperatorVoucherItem.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: TourOperator_DiscountsEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = Math.round(message.key));
    message.value !== undefined &&
      (obj.value = message.value
        ? TourOperatorVoucherItem.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<TourOperator_DiscountsEntry>
  ): TourOperator_DiscountsEntry {
    const message = createBaseTourOperator_DiscountsEntry();
    message.key = object.key ?? 0;
    message.value =
      object.value !== undefined && object.value !== null
        ? TourOperatorVoucherItem.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseTourOperator_RefundsEntry(): TourOperator_RefundsEntry {
  return { key: 0, value: undefined };
}

export const TourOperator_RefundsEntry = {
  encode(
    message: TourOperator_RefundsEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== 0) {
      writer.uint32(8).uint32(message.key);
    }
    if (message.value !== undefined) {
      TourOperatorVoucherItem.encode(
        message.value,
        writer.uint32(18).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TourOperator_RefundsEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperator_RefundsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.uint32();
          break;
        case 2:
          message.value = TourOperatorVoucherItem.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperator_RefundsEntry {
    return {
      key: isSet(object.key) ? Number(object.key) : 0,
      value: isSet(object.value)
        ? TourOperatorVoucherItem.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: TourOperator_RefundsEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = Math.round(message.key));
    message.value !== undefined &&
      (obj.value = message.value
        ? TourOperatorVoucherItem.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<TourOperator_RefundsEntry>
  ): TourOperator_RefundsEntry {
    const message = createBaseTourOperator_RefundsEntry();
    message.key = object.key ?? 0;
    message.value =
      object.value !== undefined && object.value !== null
        ? TourOperatorVoucherItem.fromPartial(object.value)
        : undefined;
    return message;
  },
};

function createBaseTourOperatorList(): TourOperatorList {
  return { items: {} };
}

export const TourOperatorList = {
  encode(
    message: TourOperatorList,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    Object.entries(message.items).forEach(([key, value]) => {
      TourOperatorList_ItemsEntry.encode(
        { key: key as any, value },
        writer.uint32(10).fork()
      ).ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TourOperatorList {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          const entry1 = TourOperatorList_ItemsEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry1.value !== undefined) {
            message.items[entry1.key] = entry1.value;
          }
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorList {
    return {
      items: isObject(object.items)
        ? Object.entries(object.items).reduce<{ [key: string]: TourOperator }>(
            (acc, [key, value]) => {
              acc[key] = TourOperator.fromJSON(value);
              return acc;
            },
            {}
          )
        : {},
    };
  },

  toJSON(message: TourOperatorList): unknown {
    const obj: any = {};
    obj.items = {};
    if (message.items) {
      Object.entries(message.items).forEach(([k, v]) => {
        obj.items[k] = TourOperator.toJSON(v);
      });
    }
    return obj;
  },

  fromPartial(object: DeepPartial<TourOperatorList>): TourOperatorList {
    const message = createBaseTourOperatorList();
    message.items = Object.entries(object.items ?? {}).reduce<{
      [key: string]: TourOperator;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = TourOperator.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseTourOperatorList_ItemsEntry(): TourOperatorList_ItemsEntry {
  return { key: "", value: undefined };
}

export const TourOperatorList_ItemsEntry = {
  encode(
    message: TourOperatorList_ItemsEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      TourOperator.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TourOperatorList_ItemsEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorList_ItemsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = TourOperator.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorList_ItemsEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value)
        ? TourOperator.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: TourOperatorList_ItemsEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined &&
      (obj.value = message.value
        ? TourOperator.toJSON(message.value)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<TourOperatorList_ItemsEntry>
  ): TourOperatorList_ItemsEntry {
    const message = createBaseTourOperatorList_ItemsEntry();
    message.key = object.key ?? "";
    message.value =
      object.value !== undefined && object.value !== null
        ? TourOperator.fromPartial(object.value)
        : undefined;
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
